import { z } from 'zod';
import { emailValidator, verificationCodeValidator } from '../../utils/common';
export const VerifySchema = z
    .object({ verificationCode: verificationCodeValidator, email: emailValidator })
    .describe('Verify object with verification code and email');
//# sourceMappingURL=verifySchema.js.map